import PropTypes from "prop-types";

import DerivedLevelsTool, {
  derivedLevelsPropTypes,
  derivedLevelsBaseDefaults,
  derivedLevelsHoverTextDefaults,
} from "./DerivedLevelsTool";
import EachTironeLevels from "./wrapper/EachTironeLevels";

// Config sobre DerivedLevelsTool (auditoria 2026-07-17, item 1d);
// a matemática dos terços vive no EachTironeLevels
class TironeLevels extends DerivedLevelsTool {}

TironeLevels.collectionKey = "tironeLevels";
TironeLevels.EachComponent = EachTironeLevels;
TironeLevels.evoId = "interactive-tirone-levels";

TironeLevels.propTypes = {
  ...derivedLevelsPropTypes,
  tironeLevels: PropTypes.array.isRequired,
};

TironeLevels.defaultProps = {
  ...derivedLevelsBaseDefaults,
  tironeLevels: [],
  hoverText: {
    ...derivedLevelsHoverTextDefaults,
    text: "Clique e arraste para criar Níveis de Tirone",
  },
};

export default TironeLevels;
